import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlightCodePipe } from './highlight-code.pipe';

@NgModule({
  declarations: [HighlightCodePipe],
  imports: [
    CommonModule
  ],
  exports: [HighlightCodePipe]
})

export class HighlightCodeModule { }
